export enum Actions {
  ADD_FEATURE_FLIP = 'ADD_FEATURE_FLIP',
  START_CONFETTI = 'START_CONFETTI',
  STOP_CONFETTI = 'STOP_CONFETTI',
}
